import React from 'react';

import { Variants } from '@amplitude/experiment-react-native-client';

import { RunningExperiments } from 'state/experiments';
import LocalStorage, { StorageKeys } from 'utils/local-storage';

import { EnvList } from './env-list';
import { HiddenSection } from './hidden-section';

const ExperimentFlagsContent = () => {
  const variants: Variants = LocalStorage.getItem(StorageKeys.AMPLITUDE_VARIANTS) || {};

  const flags = Object.values(RunningExperiments)
    .filter(s => typeof s === 'string')
    .reduce((acc, flagKey) => {
      acc[flagKey] = variants[flagKey]?.value ?? 'OFF';
      return acc;
    }, {});

  return <EnvList data={flags} />;
};

export const ExperimentFlags = () => (
  <HiddenSection title="Experiments" content={<ExperimentFlagsContent />} />
);
